module.exports = __webpack_public_path__ + "11b912801c28b545f6a869e6559245e9.png";